import { render, staticRenderFns } from "./VoicemailSetting.vue?vue&type=template&id=33cbe152&scoped=true&"
import script from "./VoicemailSetting.vue?vue&type=script&lang=js&"
export * from "./VoicemailSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33cbe152",
  null
  
)

export default component.exports